/**
 * HPQ Cart — v3.2 shipping bar + celebrations
 *
 * Updates the shipping progress bar on AJAX cart changes.
 * Threshold: $59 standard free / $9 flat
 * Celebrations: cart icon bounce, threshold crossing animation
 */
(function () {
  'use strict';

  var THRESHOLD = (window.hpqFreeShip && window.hpqFreeShip.threshold) || 5900;
  var lastStatus = null;
  var latestCart = null;

  // Free-ship state (threshold + coupon-adjusted effective total + status) is owned by
  // hpq-free-ship.js, so this bar, the drawer bar, and the nav bar always agree with each
  // other, with the coupon summary, and with checkout. Fall back to a local compute only if
  // that module somehow failed to load (defensive; load order guarantees it is present).
  function shipState(totalCents, count) {
    var fs = window.hpqFreeShip;
    if (fs) return fs.stateFor(totalCents, count);
    var eff = totalCents;
    return {
      threshold: THRESHOLD, effectiveCents: eff, remainingCents: Math.max(0, THRESHOLD - eff),
      pct: Math.min(100, Math.round((eff / THRESHOLD) * 100)), pending: false,
      status: eff >= THRESHOLD ? 'free' : (count === 0 ? 'empty' : 'flat')
    };
  }

  function updateShippingBar(state) {
    var bar = document.querySelector('[data-hpq-shipping-bar]');
    if (!bar) return;

    var fill = bar.querySelector('[data-hpq-bar-fill]');
    var msgContainer = bar.querySelector('.hpq-shipping-bar__message');
    if (!fill || !msgContainer) return;

    var status = state.status, html, cls;

    if (status === 'pending') {
      // A coupon quote is in flight — show a neutral note instead of a stale free/flat claim
      // that would flash then snap. Hold the fill where it is (no width write).
      cls = 'pending';
      html = '<span>Checking shipping…</span>';
    } else if (status === 'free') {
      cls = 'free';
      fill.style.width = '100%';
      html = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>'
        + '<span>You\'ve earned <strong>FREE shipping!</strong></span>';
    } else {
      cls = 'flat'; // 'empty' (0 items) reads as flat here: "Add $59.00 more…"
      fill.style.width = state.pct + '%';
      html = '<span>Add <strong>' + formatCents(state.remainingCents) + '</strong> more for FREE shipping'
        + '<span class="hpq-shipping-bar__sub">Current rate: $9 flat</span></span>';
    }

    msgContainer.className = 'hpq-shipping-bar__message hpq-shipping-bar__message--' + cls;
    msgContainer.innerHTML = html;

    // Threshold celebration: only on upward crossing. Pending is a transient, not a real
    // status transition, so it neither celebrates nor advances lastStatus.
    if (status !== 'pending') {
      if (lastStatus !== null && lastStatus !== cls && cls === 'free' && lastStatus === 'flat') {
        celebrateThreshold(fill);
      }
      lastStatus = cls;
    }
  }

  function celebrateThreshold(fill) {
    fill.classList.remove('hpq-shipping-bar__fill--celebrate');
    void fill.offsetWidth;
    fill.classList.add('hpq-shipping-bar__fill--celebrate');
    fill.addEventListener('animationend', function handler() {
      fill.classList.remove('hpq-shipping-bar__fill--celebrate');
      fill.removeEventListener('animationend', handler);
    });
  }

  function bounceCartIcon() {
    var cartIcon = document.querySelector('.header__icon--cart, [data-js-cart-icon], .cart-icon-bubble');
    if (!cartIcon) return;
    cartIcon.classList.remove('hpq-cart-bouncing');
    void cartIcon.offsetWidth;
    cartIcon.classList.add('hpq-cart-bouncing');
    cartIcon.addEventListener('animationend', function handler() {
      cartIcon.classList.remove('hpq-cart-bouncing');
      cartIcon.removeEventListener('animationend', handler);
    });
  }

  function formatCents(cents) {
    var dollars = Math.floor(cents / 100);
    var remainder = cents % 100;
    return '$' + dollars + '.' + String(remainder).padStart(2, '0');
  }

  // Prime latestCart from the AJAX cart on page load.
  //
  // MEASURED 2026-08-23 (scripts/uat/measure-discount-visibility.sh, live store):
  // Liquid's `cart.total_price` IS post-discount. A 3-sauce cart reports
  // original_total_price $41.97 / total_price $35.97 / total_discount $6.00, and the
  // cart page server-renders "Add $23.03 more" — the post-discount figure. So the
  // server render already agrees with checkout, and the automatic 3+ volume discounts
  // ARE visible to Liquid.
  //
  // An earlier version of this comment claimed the opposite (that Liquid renders the
  // PRE-discount total and can promise free shipping on a cart checkout charges $9 for).
  // That was never measured — it over-stated the hedge in f772215, which verified the JS
  // surfaces and not Liquid. Do not reintroduce it; re-run the script instead.
  //
  // This fetch therefore exists only to prime latestCart, which updateSuggestion needs
  // for cart_level_discount_applications, and to drive the nudge. The bar itself is
  // driven by hpq:cart-changed (below).
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      latestCart = cart;
      updateSuggestion(cart);
    });

  // The free-ship state module recomputes on every cart change, coupon quote, and section
  // load, then emits ONE event. The bar re-renders from that shared state — the single place
  // it is driven, so it can never disagree with the drawer bar or the nav bar.
  document.addEventListener('hpq:cart-changed', function (e) {
    updateShippingBar((e.detail && e.detail.freeShip) || shipState(latestCart && latestCart.total_price, latestCart && latestCart.item_count));
    if (latestCart) updateSuggestion(latestCart);
  });

  // Cart icon bounce on item added
  document.addEventListener('cart:item-added', function () {
    bounceCartIcon();
  });

  // Minimum subtotal carried by fortune coupons. Shopify evaluates it on the subtotal
  // AFTER the automatic 3+ volume discounts, so a 4-pack ($23.96 gross, $19.96 net) sits
  // 4c short — and Shopify drops the code silently. Nudge to close the gap instead.
  var COUPON_MIN = 2000;

  // Reads the fortune session the coupon UI writes. Returns null when there is no live
  // coupon, so the shipping nudge is unaffected for everyone else.
  function activeFortuneCoupon() {
    try {
      var raw = window.localStorage.getItem('hpq_fortune_session');
      if (!raw) return null;
      var sess = JSON.parse(raw);
      var f = (sess && (sess.fortune || sess.reward)) || null;
      if (!f) return null;
      var code = f.discount_code || f.code || '';
      if (!code) return null;
      var expires = f.expires_at ? Date.parse(f.expires_at) : NaN;
      if (isFinite(expires) && expires <= Date.now()) return null; // expired — don't nudge
      var pct = parseInt(f.discount !== undefined ? f.discount : f.discount_pct, 10);
      return { code: code, pct: isFinite(pct) ? pct : null };
    } catch (e) {
      return null;
    }
  }

  function suggestionFor(remainCents) {
    if (remainCents <= 599) return { name: 'a noodle pack', price: '$5.99' };
    if (remainCents <= 999) return { name: 'a soup base', price: '$9.99' };
    return { name: 'a sauce', price: '$13.99' };
  }

  // "Almost there" product suggestion.
  // Two thresholds now: the coupon minimum ($20) comes first in cart order, the
  // free-shipping threshold ($59) second. Surface whichever the cart hasn't cleared yet.
  // Is a fortune/support code already applied to this cart? Its title is the code
  // string for discount_code applications (verified: cart_level_discount_applications
  // [].title === "HPQ-FU-…"). If so, the coupon nudge must NOT fire.
  function couponAlreadyApplied(cart) {
    // A draft-flow Fortune code lives in window.hpqAppliedCoupons (sessionStorage), NOT in
    // Shopify's cart_level_discount_applications — draft-flow codes only materialize as a discount
    // at draft-order creation. Check BOTH sources, or the "add $X to unlock your coupon" nudge
    // fires even though the shopper has already applied their Fortune code. Only count the
    // sessionStorage codes when draft checkout is ENABLED: with the flag off they're inert (native
    // checkout ignores them and they persist across a flag-off reload), so counting them would
    // wrongly suppress the nudge on a cart that has no real discount.
    var draftOn = !!(window.HPQ_CONFIG && window.HPQ_CONFIG.draftCheckoutEnabled);
    var draft = (draftOn && window.hpqAppliedCoupons) || [];
    for (var d = 0; d < draft.length; d++) {
      if (draft[d] && /^HPQ-(FU|CS)-/i.test(String(draft[d].code || ''))) return true;
    }
    var apps = (cart && cart.cart_level_discount_applications) || [];
    for (var i = 0; i < apps.length; i++) {
      if (/^HPQ-(FU|CS)-/i.test(String(apps[i].title || '') + String(apps[i].code || ''))) return true;
    }
    return false;
  }

  // cart: the full /cart.js object (needed to read cart_level_discount_applications).
  function updateSuggestion(cart) {
    var container = document.querySelector('[data-hpq-threshold-suggestion]');
    if (!container) return;
    var cartTotalCents = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
    // Free-ship remaining keys on the coupon-adjusted order total (draft mode); the coupon-min
    // nudge below stays on the pre-coupon cart total (Shopify evaluates the $20 min there).
    var shipTotalCents = shipState(cartTotalCents, cart && cart.item_count).effectiveCents;

    // Coupon nudge — only when a live coupon exists AND is not already applied.
    // The $20 minimum is evaluated by Shopify on the PRE-coupon subtotal; when the
    // code is already in the cart it has by definition cleared the minimum, so a
    // "spend more to unlock" message would be both wrong and contradictory.
    if (cartTotalCents > 0 && cartTotalCents < COUPON_MIN && !couponAlreadyApplied(cart)) {
      var coupon = activeFortuneCoupon();
      if (coupon) {
        var couponGap = COUPON_MIN - cartTotalCents;
        var couponPick = suggestionFor(couponGap);
        var reward = coupon.pct ? coupon.pct + '% off' : 'your coupon';
        container.innerHTML = '<span>Add ' + couponPick.name + ' (' + couponPick.price +
          ') to unlock <strong>' + reward + '</strong></span>';
        container.removeAttribute('hidden');
        return;
      }
    }

    var remainCents = THRESHOLD - shipTotalCents;
    var nearEnough = shipTotalCents > 0 && remainCents > 0 && remainCents <= 1500;

    if (nearEnough) {
      var suggestion = suggestionFor(remainCents);
      container.innerHTML = '<span>Add ' + suggestion.name + ' (' + suggestion.price + ') for <strong>FREE shipping</strong></span>';
      container.removeAttribute('hidden');
    } else {
      container.setAttribute('hidden', '');
    }
  }

  // Hook suggestion updates into cart:updated
  document.addEventListener('cart:updated', function (e) {
    var cart = (e.detail && e.detail.cart) || e.detail;
    if (cart && typeof cart.total_price === 'number') {
      latestCart = cart;
      updateSuggestion(cart);
    }
  });

  // Shopify section rendering — the bar re-renders via hpq:cart-changed (hpq-free-ship.js
  // also listens to shopify:section:load); here we only refresh latestCart + the nudge.
  document.addEventListener('shopify:section:load', function () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { latestCart = cart; updateSuggestion(cart); });
  });
})();
